import React, { useState } from "react";

import { Row } from "@masterteam/mt-design-react";

import List from "./List";
import MovementControls from "./MovementControls";

function GroupsPicker({
  list = [],
  selected = [],
  onChange,
  label1 = "List",
  label2 = "Selected",
  nameKey = "EnglishName",
  valueKey = "ID",
  error
}) {
  const [unassigned, setUnassigned] = useState([]);
  const [assigned, setAssigned] = useState([]);

  function getUsersFiltered() {
    const _selected = selected?.map(e => e?.[valueKey]);
    return list?.filter(item => !_selected?.includes(item?.[valueKey]));
  }

  function handleChange(type) {
    if (type === "assign" && assigned?.length) {
      onChange(selected?.concat(assigned));
      setAssigned([]);
    } else if (type === "unassign" && unassigned?.length) {
      const _selected = unassigned?.map(e => e?.[valueKey]);
      const newSelected = selected?.filter(
        e => !_selected?.includes(e?.[valueKey])
      );
      onChange(newSelected);
      setUnassigned([]);
    } else if (type === "assign-all") {
      onChange(list);
      setAssigned([]);
    } else if (type === "unassign-all") {
      onChange([]);
      setUnassigned([]);
    }
  }

  return (
    <Row size="medium" justify="between" align="end">
      <List
        users={getUsersFiltered()}
        title={label1}
        valueKey={valueKey}
        nameKey={nameKey}
        selectedUsers={assigned}
        setSelectedUsers={setAssigned}
      />
      <MovementControls
        onChange={handleChange}
        assigned={assigned}
        unassigned={unassigned}
        allSelected={list?.length === selected?.length}
        nothingSelected={!selected?.length}
      />
      <List
        users={selected}
        title={label2}
        valueKey={valueKey}
        nameKey={nameKey}
        selectedUsers={unassigned}
        setSelectedUsers={setUnassigned}
        error={error}
      />
    </Row>
  );
}

export default GroupsPicker;
